<div class="hendelseslogg">
  <div class="hendelseslogg-topp">
    <div class="hendelseslogg-tittel">
      <h4>{{ 'Endringshendelser' | translate }}</h4>
      @if (totalantall() > 0) {
        <span class="hendelseslogg-antall">({{ totalantall() }})</span>
      }
    </div>
    <div class="hendelseslogg-kontroller">
      <mat-form-field appearance="outline" subscriptSizing="dynamic" class="sortering-felt">
        <mat-label>{{ 'Sortering' | translate }}</mat-label>
        <mat-select [value]="sortering()" (valueChange)="byttSortering($event)" data-testid="sortering-select">
          <mat-option [value]="SorteringEnum.synkende" data-testid="sortering-synkende">
            {{ 'Nyeste først' | translate }}
          </mat-option>
          <mat-option [value]="SorteringEnum.stigende" data-testid="sortering-stigende">
            {{ 'Eldste først' | translate }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </div>

  @if (laster()) {
    <div class="hendelseslogg-laster" data-testid="hendelseslogg-laster">
      {{ 'Laster endringshendelser...' | translate }}
    </div>
  }

  @if (!laster()) {
    @if (hendelser().length > 0) {
      <table class="hendelseslogg-tabell" data-testid="hendelseslogg-tabell">
        <thead>
          <tr>
            <th>{{ 'Utførtdato' | translate }}</th>
            <th>{{ 'Entitetstype' | translate }}</th>
            <th>{{ 'Endringstype' | translate }}</th>
            <th>{{ 'Subendringstype' | translate }}</th>
            <th>{{ 'Beskrivelse' | translate }}</th>
            <th>{{ 'Bruker' | translate }}</th>
          </tr>
        </thead>
        <tbody>
          @for (hendelse of hendelser(); track hendelse.id) {
            <tr class="hendelseslogg-element" [class.klikkbar]="true" (click)="veksleEkspandert(hendelse)" data-testid="hendelse-element">
              <td class="hendelseslogg-utfoert-dato">
                <time class="hendelseslogg-dato" [title]="hendelse.utfoertDato | zoneddatetime:'long'">
                  {{ hendelse.utfoertDato | zoneddatetime:'medium' }}
                </time>
                <span class="hendelseslogg-relativ-tid">
                  ({{ hendelse.utfoertDato | zoneddatetime_relativ | async }})
                </span>
              </td>
              <td class="hendelseslogg-entitet-type">
                {{ hendelse.entitetReferanse?.type }}
              </td>
              <td class="hendelseslogg-endringstype">
                {{ endringstypeNavn(hendelse.endringstype) }}
              </td>
              <td class="hendelseslogg-sub-endringstype">
                {{ subEndringstypeNavn(hendelse.subEndringstype) }}
              </td>
              <td class="hendelseslogg-beskrivelse-celle">
                <div class="hendelseslogg-beskrivelse" [innerHTML]="hendelse.beskrivelse | strengMal"></div>
              </td>
              <td class="hendelseslogg-bruker-celle">
                @if (hendelse.bruker) {
                  <div class="hendelseslogg-bruker">
                    <avatar [bruker]="hendelse.bruker" stil="liten"/>
                    <span>{{ hendelse.bruker.navnEllerEpost }}</span>
                  </div>
                }
              </td>
            </tr>
            @if(!erEpost(hendelse) && erEkspandert(hendelse)){
            <tr >
              <td colspan="6">
                <pre style="font-family: monospace;">{{ hendelse | json }}</pre>
              </td>
            </tr>
            }
            @if (erEpost(hendelse) && erEkspandert(hendelse)) {
              <tr class="hendelseslogg-epost-rad" data-testid="hendelse-epost-rad">
                <td colspan="6">
                  <div class='wkeh-epost' flex="grow">
                    <iframe-auto-hoyde [html]="hendelse.beskrivelse.noeklerOgVerdier.beskrivelse.htmlKropp"/>
                  </div>
                </td>
              </tr>
            }
          }
        </tbody>
      </table>

      @if (totalantall() > antall()) {
        <div class="hendelseslogg-paginering" data-testid="hendelseslogg-paginering">
          <span class="paginering-info">
            {{ 'Viser {fra}–{til} av {total}' | translate:{fra: viserFra(), til: viserTil(), total: totalantall()} }}
          </span>
          <div class="paginering-knapper">
            <button mat-button type="button" [disabled]="!harForrigeSide()" (click)="forrigeSide()" data-testid="forrige-side-knapp">
              {{ 'Forrige' | translate }}
            </button>
            <button mat-button type="button" [disabled]="!harNesteSide()" (click)="nesteSide()" data-testid="neste-side-knapp">
              {{ 'Neste' | translate }}
            </button>
          </div>
        </div>
      }
    } @else {
      <div class="hendelseslogg-tom" data-testid="hendelseslogg-tom">
        {{ 'Ingen endringshendelser funnet' | translate }}
      </div>
    }
  }
</div>
